import Keycloak from 'keycloak-js';
import Cookies from 'js-cookie';
import { captureException } from '@sentry/browser';
import TimeInMilliseconds from '@common/time/TimeInMilliseconds';
import TimeInSeconds from '@common/time/TimeInSeconds';
import EventService from '@common/event/EventService';
import AuthEvent from './vcom/events/AuthEvent';

window.keycloakWrapper = ({
  clientId, realm, url,
}, baseUrl) => {
  const keycloak = new Keycloak({
    clientId,
    realm,
    url,
  });

  const keycloakState = {
    IS_READY: null,
    MARK_READY: null,
  };

  keycloakState.IS_READY = new Promise((resolve) => {
    keycloakState.MARK_READY = resolve;
  });

  const redirectUri = `${baseUrl}default/login-oauth/logout`;

  async function saveState() {
    const cookieToken = {
      accessToken: keycloak.token,
      refreshToken: keycloak.refreshToken,
    };
    await fetch(
      `${baseUrl}default/login-oauth/set-tokens`,
      { method: 'POST', body: JSON.stringify({ tokens: cookieToken }) },
    );
    EventService.dispatch(AuthEvent.TOKEN_REFRESHED);
    localStorage.setItem('keycloak', JSON.stringify(keycloak));
  }
  return {
    async signin() {
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');
      keycloak.clearToken();
      const loginInitOptions = {
        onLoad: 'login-required',
        checkLoginIframe: false,
      };

      const isAuthenticated = await keycloak.init(loginInitOptions);
      keycloakState.MARK_READY(isAuthenticated);
      await saveState();
      window.location.href = '/vcom/';
    },
    async updateTokenIfExpired() {
      try {
        const tokenHasRefreshed = await keycloak.updateToken(TimeInSeconds.FIVE_MINUTES);
        if (tokenHasRefreshed) {
          await saveState();
        }
      } catch {
        // eslint-disable-next-line fp/no-this
        await this.signout();
      }
    },
    async checkSSO() {
      const keycloakInput = JSON.parse(localStorage.getItem('keycloak'));
      const loginInitOptions = {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        token: keycloakInput.token,
        refreshToken: keycloakInput.refreshToken,
        idToken: keycloakInput.idToken,
      };
      try {
        const isAuthenticated = await keycloak.init(loginInitOptions);
        keycloakState.MARK_READY(isAuthenticated);
      } catch {
        // eslint-disable-next-line fp/no-this
        await this.signout();
        return;
      }
      setInterval(async () => {
        // eslint-disable-next-line fp/no-this
        await this.updateTokenIfExpired();
      }, TimeInMilliseconds.MINUTE * 5);
    },
    async signout() {
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');
      localStorage.removeItem('keycloak');
      try {
        await keycloak.logout({ redirectUri, id_token_hint: keycloak.idToken });
      } catch {
        window.location.href = redirectUri;
      }
    },
    async getAccessToken() {
      if (localStorage.getItem('keycloak')) {
        await keycloakState.IS_READY;
        // eslint-disable-next-line fp/no-this
        await this.updateTokenIfExpired();
        return keycloak.token;
      }
      const accessToken = Cookies.get('accessToken');
      if (accessToken === undefined) {
        captureException(new Error('Keycloak access token is empty'));
        return null;
      }

      return accessToken;
    },
  };
};
